import React, { Component, PropTypes } from 'react';
import ReactLoader from 'react-loader-advanced';
import classNames from 'classnames';

class Spinner extends Component {

  render() {
    const {
      children,
      isGlobal,
      slim,
      message,
      backgroundStyle = { position: 'absolute' }
    } = this.props;

    const Message = (
      <div className="spinner-container">
        <div className={classNames('spinner', { 'slim': slim }, { 'spinner-inline': !isGlobal })}>
          <div className="bounce1" />
          <div className="bounce2" />
          <div className="bounce3" />
        </div>
        {message &&
          <h2 className="spinner-message x-heading3">{message}</h2>
        }
      </div>
    );

    return (
      <ReactLoader
        backgroundBlur={47}
        backgroundStyle={{ backgroundColor: 'rgba(0,0,0,0.15)', ...backgroundStyle }}
        {...this.props}
        message={Message}
      >
        {children}
      </ReactLoader>
    );
  }
}

Spinner.propTypes = {
  children: PropTypes.node,
  isGlobal: PropTypes.bool,
  backgroundStyle: PropTypes.object,
  slim: PropTypes.bool,
  message: PropTypes.string
};

export default Spinner;



/** WEBPACK FOOTER **
 ** ./client/components/Common/Spinner/Spinner.jsx
 **/